export const removeEmptyFields = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const trimAllFields = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[key] = typeof value === "string" ? value.trim() : value;
    return acc;
  }, {});
};

export const sanitizeFormData = (obj) => {
  return removeEmptyFields(trimAllFields(obj));
};

// ── Package state mapping ─────────────────────────────────────────────────────
const BASE_STATES = {
  110: "Pending",
  118: "Removed",
  121: "Overstay",
  128: "Claimed",
  150: "Cancelled",
  158: "Cleared Out",
};

const WITHOUT_INTEGRATION_STATES = {
  130: "Take-Back",
  138: "Revoked",
};

const WITH_INTEGRATION_STATES = {
  140: "For RTS",
  141: "RTS Overstay",
  148: "RTS",
};

export const PARTNER_STATES = {
  300: "New",
  310: "Drop-Off",
  320: "Pending",
  328: "Claimed",
  350: "Cancelled",
};

export const PACKAGE_STATES = {
  with_integration: {
    ...WITH_INTEGRATION_STATES,
    ...BASE_STATES,
  },
  without_integration: {
    ...WITHOUT_INTEGRATION_STATES,
    ...BASE_STATES,
  },
};
